import axios from "axios"

const NAVIGATION_ENDPOINT_ATTRIBUTE = 'data-dynamic-navigation-endpoint';

const desktopColumnsContainer = document.querySelector(".wilo-header__flyout-columns");
const mobileNavContainer = document.querySelector(".wilo-header__mobile-nav-body");
const dynamicNavigations = document.querySelectorAll(`[${NAVIGATION_ENDPOINT_ATTRIBUTE}]`);

/**
 * A map which contains request for dynamic navigation items to
 * prevent multiple requests to the same url. The key is the requested url.
 *
 * @type {Record<string, Promise<Navigation[]>>}
 */
const promiseMap = {}

// Init and fill all dynamic navigations with specific data attribute
dynamicNavigations.forEach(navigationElement => {
    const endpointUrl = navigationElement.getAttribute(NAVIGATION_ENDPOINT_ATTRIBUTE);

    if (endpointUrl !== undefined) {
        promiseMap[endpointUrl] ??= axios
            .get(endpointUrl)
            .catch(error => console.log(error))
            .then(response => {
                try {
                    // Get navigation data from JSON response
                    // the new endpoint provides data via "result". we leave
                    // backwards compatibility with "root" for now.
                    // @see https://ciao-adesso.atlassian.net/browse/WAM-147
                    const results =
                        "result" in response.data
                            ? response.data.result
                            : response.data.root;
                    return results[0].navigation;
                } catch (error) {
                    console.log(error);
                }
            });

        promiseMap[endpointUrl].then(navigationData => {
            if (navigationData) {
                // Create navigation categories
                navigationData.forEach((navCategoryData) => {
                    if (navigationElement.closest(".wilo-header__mobile-nav") != null) {
                        appendMobileCategory(navigationElement, navCategoryData);
                    } else {
                        appendDesktopCategory(navigationElement, navCategoryData);
                    }
                });
            }
        })
    }
});

/** @typedef {{url: string, name: string, desc: string, subnavigation?: Navigation[] }} Navigation */

/**
 * Creates and appends a navigation category
 *
 * @param {HTMLElement} menuContainerElement
 * @param {Navigation} navCategoryData
 */
function appendDesktopCategory(menuContainerElement, navCategoryData) {
    const hasChildren = Array.isArray(navCategoryData.subnavigation) && navCategoryData.subnavigation.length > 0;

    const menuEntryElement = document.createElement("li");
    menuEntryElement.classList.add("wilo-header__l2-item");

    const menuLinkElement = document.createElement("a");
    menuLinkElement.classList.add("wilo-header__l2-link");
    menuLinkElement.href = getPFinderBaseUrl() + navCategoryData.url;
    if (hasChildren) {
        menuLinkElement.setAttribute("data-show-l3", navCategoryData.name);
    }

    const menuLinkSpan = document.createElement("span");
    menuLinkSpan.innerText = navCategoryData.desc;
    menuLinkElement.appendChild(menuLinkSpan);

    menuEntryElement.append(menuLinkElement);

    if (hasChildren) {
        const menuChildrenArrow = document.createElement("span");
        menuChildrenArrow.classList.add("wilo-header__l2-arrow");
        menuChildrenArrow.innerText = "›";

        menuLinkElement.append(menuChildrenArrow);
    }

    menuContainerElement.appendChild(menuEntryElement);

    // create new element for third level entries if available
    if (hasChildren) {
        const subMenuElement = document.createElement("ul");
        subMenuElement.classList.add("wilo-header__l3-list");
        subMenuElement.setAttribute("data-l3-id", navCategoryData.name);
        subMenuElement.setAttribute("aria-hidden", "true");
        subMenuElement.innerHTML += navCategoryData.subnavigation.map((entry) => `
                    <li class="wilo-header__l3-item">
                        <a class="wilo-header__l3-link" href="${getPFinderBaseUrl() + entry.url}">${entry.desc}</a>
                    </li>
                `).join("");

        desktopColumnsContainer.append(subMenuElement);
    }
}

/**
 * Creates and appends a navigation category
 *
 * @param {HTMLElement} menuContainerElement
 * @param {Navigation} navCategoryData
 */
function appendMobileCategory(menuContainerElement, navCategoryData) {
    const hasChildren = Array.isArray(navCategoryData.subnavigation) && navCategoryData.subnavigation.length > 0;

    const menuEntryElement = document.createElement("li");

    const menuLinkElement = document.createElement("a");
    menuLinkElement.classList.add("wilo-header__mobile-nav-link");
    menuLinkElement.href = getPFinderBaseUrl() + navCategoryData.url;
    menuLinkElement.innerText = navCategoryData.desc;

    menuEntryElement.append(menuLinkElement);
    if (hasChildren) {
        menuEntryElement.setAttribute("data-show-l3", navCategoryData.name);
        const menuChildrenArrow = document.createElement("span");
        menuChildrenArrow.classList.add("wilo-header__mobile-nav-arrow");
        menuChildrenArrow.innerText = "›";

        menuEntryElement.append(menuChildrenArrow);
    }

    menuContainerElement.appendChild(menuEntryElement);

    // create new element for third level entries if available
    if (hasChildren) {
        const subMenuElement = document.createElement("ul");
        subMenuElement.classList.add("wilo-header__mobile-l3");
        subMenuElement.setAttribute("data-l3-id", navCategoryData.name);
        subMenuElement.setAttribute("aria-hidden", "true");
        subMenuElement.innerHTML += navCategoryData.subnavigation.map((entry) => `
            <li>
                <a class="wilo-header__mobile-nav-link" href="${getPFinderBaseUrl() + entry.url}">${entry.desc}</a>
            </li>
        `).join("");

        mobileNavContainer.append(subMenuElement);
    }
}

/**
 * Gets pfinder base url for dynamic navigation links
 *
 * @return {string} PFinder base url if configured, otherwise empty string
 */
const getPFinderBaseUrl = () => {
    try {
        return window.wiloconfig.pfinderIntegration.pfinderLocation;
    } catch (error) {
        console.log('PFinder location base url is not defined in *window.wiloconfig*');

        return '';
    }
}
